import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  const beforeAfterImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/tjxCf81pZ5WWarfPabayDv/Images-1_(1).png',
    caption: 'Marcus T., 38 — Austin, TX. Norwood III. Baseline → Month 6. 10 min/day, 6x/week.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/wwKBJJbdUZSi7NQKHiBgEE/Images-9.png',
    caption: 'Daniel R., 44 — San Jose, CA. Norwood IIIv. Baseline → Month 5. 10 min/day, 5x/week.'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/wtwAhnDETxtaP4MZqL2EGd/Images-10.png',
    caption: 'James K., 36 — Denver, CO. Norwood II. Baseline → Month 4. 10 min/day, 7x/week.'
  }];
  const testimonials = [{
    quote: '"Three months away from booking a transplant consult. Decided to try this first. Visible new growth at my temples by month four. I wish I had started a year earlier."',
    name: 'Marcus T., 38',
    location: 'Austin, TX'
  }, {
    quote: '"Technical background, so I read every study before buying. The wavelength is right. The power density is right. Crown is noticeably thicker at month five."',
    name: 'Daniel R., 44',
    location: 'San Jose, CA'
  }, {
    quote: '"Stopped finasteride after six weeks. With this: no side effects, no hormone anxiety. Scalp stopped itching within three weeks. Hair progress came later."',
    name: 'James K., 36',
    location: 'Denver, CO'
  }];
  return <section className="w-full bg-white py-20 px-4" data-id="element-219">
      <div className="max-w-6xl mx-auto" data-id="element-220">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-221">
          {/* Headline */}
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-222">
            Real Men. Real Scalps. 6–12 Month Results.
          </h2>
          <p className="text-lg text-gray-600 mb-12 text-center max-w-2xl mx-auto" data-id="element-223">
            Men who acted while the window was open. Same protocol. Documented
            progress.
          </p>

          {/* Before/After Image Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-224">
            {beforeAfterImages.map((image, index) => <motion.div key={index} initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-gray-50 border border-gray-200 rounded-lg overflow-hidden" data-id="element-225">
                {/* Image */}
                <div className="bg-white p-2" data-id="element-226">
                  <img src={image.src} alt={image.caption} className="w-full h-auto" data-id="element-227" />
                </div>
                {/* Caption */}
                <div className="p-4" data-id="element-228">
                  <p className="text-sm text-gray-700" data-id="element-229">{image.caption}</p>
                </div>
              </motion.div>)}
          </div>

          {/* Compact Testimonials */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-230">
            {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="bg-gray-50 border-l-4 border-brand-red rounded-lg p-6" data-id="element-231">
                <p className="text-gray-700 italic mb-4 text-sm leading-relaxed" data-id="element-232">
                  {testimonial.quote}
                </p>
                <p className="text-gray-900 font-semibold text-sm" data-id="element-233">
                  — {testimonial.name}
                </p>
                <p className="text-gray-600 text-xs" data-id="element-234">{testimonial.location}</p>
              </motion.div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}